import React from "react";

// importar editorial
// 1-No Way is Far AWay
import ed1_0 from "../img/editorial/1/image1.jpg";
import ed1_1 from "../img/editorial/1/image2.jpg";
import ed1_2 from "../img/editorial/1/image3.jpg";
import ed1_3 from "../img/editorial/1/image4.jpg";
import ed1_4 from "../img/editorial/1/image5.jpg";
import ed1_5 from "../img/editorial/1/image6.jpg";
import ed1_6 from "../img/editorial/1/image7.jpg";
// 2- When the sun goes down
import ed2_0 from "../img/editorial/2/image1.jpg";
import ed2_1 from "../img/editorial/2/image2.jpg";
import ed2_2 from "../img/editorial/2/image3.jpg";
import ed2_3 from "../img/editorial/2/image4.jpg";
import ed2_4 from "../img/editorial/2/image5.jpg";
import ed2_5 from "../img/editorial/2/image6.jpg";
// 3- Tommy Boy
import ed3_0 from "../img/editorial/3/image1.jpg";
import ed3_1 from "../img/editorial/3/image2.jpg";
import ed3_2 from "../img/editorial/3/image3.jpg";
import ed3_3 from "../img/editorial/3/image4.jpg";
import ed3_4 from "../img/editorial/3/image5.jpg";
import ed3_5 from "../img/editorial/3/image6.jpg";
// 4- Gwapa
import ed4_0 from "../img/editorial/4/image1.jpg";
import ed4_1 from "../img/editorial/4/image2.jpg";
import ed4_2 from "../img/editorial/4/image3.jpg";
import ed4_3 from "../img/editorial/4/image4.jpg";
import ed4_4 from "../img/editorial/4/image5.jpg";
// 5- More photos
import ed5_0 from "../img/editorial/5/image1.jpg";
import ed5_1 from "../img/editorial/5/image2.jpg";
import ed5_2 from "../img/editorial/5/image3.jpg";
import ed5_3 from "../img/editorial/5/image4.jpg";
import ed5_4 from "../img/editorial/5/image5.jpg";
import ed5_5 from "../img/editorial/5/image6.jpg";
import ed5_6 from "../img/editorial/5/image7.jpg";
// importar produtos
// 1- Heineken
import prod1_3 from "../img/produtos/1/image1.jpg";
import prod1_1 from "../img/produtos/1/image2.jpg";
import prod1_2 from "../img/produtos/1/image3.jpg";
import prod1_0 from "../img/produtos/1/image4.jpg";
import prod1_4 from "../img/produtos/1/image5.jpg";
// 2- Vinhos
import prod2_2 from "../img/produtos/2/image.jpg";
import prod2_0 from "../img/produtos/2/image1.jpg";
import prod2_1 from "../img/produtos/2/image2.jpg";
// 3- Mais bebidas
import prod3_1 from "../img/produtos/3/image1.jpg";
import prod3_0 from "../img/produtos/3/image2.jpg";
import prod3_2 from "../img/produtos/3/image3.jpg";
import prod3_3 from "../img/produtos/3/image4.jpg";
// 4- Adidas U Path Run
import prod4_0 from "../img/produtos/4/image1.jpg";
import prod4_1 from "../img/produtos/4/image2.jpg";
import prod4_2 from "../img/produtos/4/image3.jpg";
import prod4_3 from "../img/produtos/4/image4.jpg";
import prod4_4 from "../img/produtos/4/image5.jpg";
// 5- Nike
import prod5_0 from "../img/produtos/5/image1.jpg";
// 6- Giorgio Armani
import prod6_0 from "../img/produtos/6/image1.jpg";
import prod6_1 from "../img/produtos/6/image2.jpg";
// 7- Mais Perfumes e Cremes
import prod7_0 from "../img/produtos/7/image1.jpg";
import prod7_1 from "../img/produtos/7/image2.jpg";
// 8- Gadgets
import prod8_0 from "../img/produtos/8/image1.jpg";
import prod8_1 from "../img/produtos/8/image2.jpg";
import prod8_2 from "../img/produtos/8/image3.jpg";


class Portfolio extends React.Component {
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Editorial</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={ed1_0} data-lightbox="gallery-vmarine">
                  <div className="work-img">
                    <img src={ed1_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">No Way is far away</h2>
                        <div className="w-more">
                          <span className="w-date">
                          A brisa do verão que desperta o teu estilo, as roupas largas que dançam ao vento assim como os cabelos. A pele dourada pelo sol que contrasta com o céu azul. Uma explosão de cores esplendidas, aromas refrescantes e melodias alegres que retornam nesta época. Roupas com cortes retro que perduram para lá do seu tempo. 
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={ed1_1}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed1_2}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed1_3}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed1_4}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed1_5}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed1_6}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={ed2_0} data-lightbox="gallery-aguadeluz">
                  <div className="work-img">
                    <img src={ed2_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">When the sun goes down</h2>
                        <div className="w-more">
                          <span className="w-date">
                          As luzes da noite, iluminam as roupas mais discretas para um estilo mais arrojado.  Um vestido prático e leve com uma renda que se entrelaça num padrão de flores monocromáticas, ou umas calças caneladas pretas com uma t-shirt preta básica, são a escolha perfeita para quem quer sair nas noites quentes de verão.  
                          </span>{" "}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={ed2_1}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed2_2}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed2_3}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed2_4}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed2_5}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >

                </a>
                
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={ed3_0} data-lightbox="gallery-todo">
                  <div className="work-img">
                    <img src={ed3_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Tommy Boy</h2>
                        <div className="w-more">
                          <span className="w-date">
                          Tommy boy é um conjunto de imagens que mostra um estilo de roupa elegante e moderno, misturado com o streetwear. 
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={ed3_1}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed3_2}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed3_3}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed3_4}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed3_5}
                  data-lightbox="gallery-todo"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={ed4_0} data-lightbox="gallery-medlingos">
                  <div className="work-img">
                    <img src={ed4_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Gwapa</h2>
                        <div className="w-more">
                          <span className="w-date">
                          Mostra-te como és, o mundo está a teu favor, com ou sem maquilhagem, liberta-te da imagem da pessoa com um penteado superproduzido e com traços artificiais produzidos com makeup. Esta beleza natural pode ser melhorada com alguns cuidados básicos do dia-a-dia como uma alimentação equilibrada, skin care, exercício físico, entre outras coisas.  

                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={ed4_1}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed4_2}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed4_3}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed4_4}
                  data-lightbox="gallery-medlingos"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={ed5_0} data-lightbox="gallery-smth">
                  <div className="work-img">
                    <img src={ed5_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">More Photos</h2>
                        <div className="w-more">
                          <span className="w-date">Seleção de imagens de vários projetos.</span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={ed5_6}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed5_1}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed5_2}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed5_3}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed5_4}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={ed5_5}
                  data-lightbox="gallery-smth"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
          </div>
        </div>


        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Produtos</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod1_0} data-lightbox="gallery-heineken">
                  <div className="work-img">
                    <img src={prod1_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Heineken</h2>
                       
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod1_1}
                  data-lightbox="gallery-heineken"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod1_2}
                  data-lightbox="gallery-heineken"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod1_3}
                  data-lightbox="gallery-heineken"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod1_4}
                  data-lightbox="gallery-heineken"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod2_2} data-lightbox="gallery-vinhos">
                  <div className="work-img">
                    <img src={prod2_2} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Vinhos</h2>
                        
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod2_0}
                  data-lightbox="gallery-vinhos"
                  style={{ display: "none" }}
                >
                </a>
                <a
                  href={prod2_1}
                  data-lightbox="gallery-vinhos"
                  style={{ display: "none" }}
                >
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod3_0} data-lightbox="gallery-bebidas">
                  <div className="work-img">
                    <img src={prod3_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Mais bebidas</h2>
  
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod3_3}
                  data-lightbox="gallery-bebidas"
                  style={{ display: "none" }}
                ></a>
                <a
                  href={prod3_1}
                  data-lightbox="gallery-bebidas"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod3_2}
                  data-lightbox="gallery-bebidas"
                  style={{ display: "none" }}
                >
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod6_0} data-lightbox="gallery-mf">
                  <div className="work-img">
                    <img src={prod6_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Giorgio Armani</h2>
                        <div className="w-more">
                         
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod6_1}
                  data-lightbox="gallery-mf"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod7_0} data-lightbox="gallery-mpc">
                  <div className="work-img">
                    <img src={prod7_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Mais Perfumes e Cremes</h2>
                        
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod7_1}
                  data-lightbox="gallery-mpc"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod5_0} data-lightbox="gallery-nike">
                  <div className="work-img">
                    <img src={prod5_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Nike</h2>
                        
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod4_0} data-lightbox="gallery-adidas">
                  <div className="work-img">
                    <img src={prod4_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Adidas U Path Run</h2>
                        <div className="w-more">
                          <span className="w-date">
                          Os ténis U Path Run da Adidas apresentam um design inspirado nos anos 70 que dá um ar de Retro e ao mesmo tempo moderno a estes. Os ténis apresentam um sistema de atacadores com ilhós em D que adiciona um visual distinto, uma peça elástica no calcanhar e a entressola leve em EVA adiciona um conforto para todo o dia. 
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod4_1}
                  data-lightbox="gallery-adidas"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod4_2}
                  data-lightbox="gallery-adidas"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod4_3}
                  data-lightbox="gallery-adidas"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod4_4}
                  data-lightbox="gallery-adidas"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={prod8_0} data-lightbox="gallery-gadgets">
                  <div className="work-img">
                    <img src={prod8_0} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-8">
                        <h2 className="w-title">Gadgets</h2>
                        
                      </div>
                      <div className="col-sm-4">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={prod8_1}
                  data-lightbox="gallery-gadgets"
                  style={{ display: "none" }}
                >

                </a>
                <a
                  href={prod8_2}
                  data-lightbox="gallery-gadgets"
                  style={{ display: "none" }}
                >

                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
